import { useDispatch as reactReduxUseDispatch } from 'react-redux';

import { Dispatch } from '../ReduxStore/types';

export const useDispatch = (): Dispatch => reactReduxUseDispatch<Dispatch>();
